export default [
  {
    name: `Diğer`,
    photo: `/images/43-min.webp`,
    width: 40,
    depth: 60,
    height: 40,
  },
];
